/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionActionSlackQueryVariables = {};
export type SuggestionActionSlackQueryResponse = {
    readonly viewer: {
        readonly id: string;
        readonly user: {
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly " $fragmentRefs": FragmentRefs<"SuggestionActionSlack_org">;
                    } | null;
                } | null> | null;
            };
        } | null;
    };
};
export type SuggestionActionSlackQuery = {
    readonly response: SuggestionActionSlackQueryResponse;
    readonly variables: SuggestionActionSlackQueryVariables;
};



/*
query SuggestionActionSlackQuery {
  viewer {
    id
    user {
      orgs(first: 1000000) {
        edges {
          node {
            ...SuggestionActionSlack_org
            id
          }
        }
      }
      id
    }
  }
}

fragment SuggestionActionSlack_org on Org {
  id
  slackAccountsErrorable {
    __typename
    ... on SlackAccountList {
      list {
        slackTeamId
        slackUserId
        teamDisplayName
        id
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  slackSettingsErrorable {
    __typename
    ... on SlackSettingsList {
      list {
        id
        slackTeamId
        slackUserId
        calendarStatus {
          calendarStatusEnabled
          includeMeetingCategory
          includeMeetingTitle
        }
        dailyDigestSettings {
          enabled
          timeSlot
        }
        dndSettings {
          focusTime
          meeting
        }
        notificationSettings {
          defragSummary
        }
        calendarStatusEnabled
        includeMeetingCategory
        includeMeetingTitle
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackTeamId",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackUserId",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarStatusEnabled",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingCategory",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingTitle",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "SuggestionActionSlackQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "SuggestionActionSlack_org"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "SuggestionActionSlackQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "slackAccountsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SlackAccount",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v3 /*: any*/),
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "teamDisplayName",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v0 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SlackAccountList",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v6 /*: any*/)
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "slackSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SlackSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v0 /*: any*/),
                                                                                (v3 /*: any*/),
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackCalendarStatusSync",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "calendarStatus",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v7 /*: any*/),
                                                                                        (v8 /*: any*/),
                                                                                        (v9 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackDailyDigestSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "dailyDigestSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "enabled",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "timeSlot",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackDndSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "dndSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "focusTime",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "meeting",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackNotificationSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "notificationSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defragSummary",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v7 /*: any*/),
                                                                                (v8 /*: any*/),
                                                                                (v9 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SlackSettingsList",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v6 /*: any*/),
                                                                        (v5 /*: any*/)
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v0 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "844f7f2e65174c9eb8d4f42e9b598f43",
            "id": null,
            "metadata": {},
            "name": "SuggestionActionSlackQuery",
            "operationKind": "query",
            "text": "query SuggestionActionSlackQuery {\n  viewer {\n    id\n    user {\n      orgs(first: 1000000) {\n        edges {\n          node {\n            ...SuggestionActionSlack_org\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment SuggestionActionSlack_org on Org {\n  id\n  slackAccountsErrorable {\n    __typename\n    ... on SlackAccountList {\n      list {\n        slackTeamId\n        slackUserId\n        teamDisplayName\n        id\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  slackSettingsErrorable {\n    __typename\n    ... on SlackSettingsList {\n      list {\n        id\n        slackTeamId\n        slackUserId\n        calendarStatus {\n          calendarStatusEnabled\n          includeMeetingCategory\n          includeMeetingTitle\n        }\n        dailyDigestSettings {\n          enabled\n          timeSlot\n        }\n        dndSettings {\n          focusTime\n          meeting\n        }\n        notificationSettings {\n          defragSummary\n        }\n        calendarStatusEnabled\n        includeMeetingCategory\n        includeMeetingTitle\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '6be46867cbe48ea0737cdcd5762c89d9';
export default node;
